/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * as comment from "./vod/comment.js";
export * as createDraft from "./vod/createDraft.js";
export * as defs from "./vod/defs.js";
export * as deleteDraft from "./vod/deleteDraft.js";
export * as draftDefs from "./vod/draftDefs.js";
export * as draftVideo from "./vod/draftVideo.js";
export * as gate from "./vod/gate.js";
export * as getComments from "./vod/getComments.js";
export * as getDraft from "./vod/getDraft.js";
export * as listDrafts from "./vod/listDrafts.js";
export * as publishDraft from "./vod/publishDraft.js";
export * as updateDraft from "./vod/updateDraft.js";
